import { Component, ViewEncapsulation, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LoginService, STEP } from 'src/app/services/login.service';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../atoms/spinner/spinner.component';
import { RESPONSE_TOKEN } from 'src/app/utils/enums/token.enum';

const LOADER_COPY = {
  default: {
    title: 'Un momento, por favor',
    message: 'Te estamos conectando con tu cuenta Copec.',
  },
  bridge: {
    title: 'Te estamos llevando a tu destino',
    message: 'Esto tomará solo unos segundos.',
  },
};

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LayoutComponent {
  public service = inject(LoginService);
  public STEP = STEP;
  public loading: boolean = true;
  public loaderCopy = this.service.hasBridgeToken ? LOADER_COPY.bridge : LOADER_COPY.default;
  ngOnInit() {
    this.listenAuthorized();
  }
  private listenAuthorized(): void {
    this.service.isAuthorized.subscribe((value: RESPONSE_TOKEN) => {
      switch (value) {
        case RESPONSE_TOKEN.EQUIPO_CREADO:
          // INITIAL STEP
          this.loading = false;
          break;
        case RESPONSE_TOKEN.TOKEN_VIGENTE_CON_VALIDA:
          // INITIAL STEP
          this.loading = false;
          break;
        case RESPONSE_TOKEN.LOADING:
          this.loading = true;
          break;
        default:
          this.loading = false;
          break;
      }

    });

  }

  public showBanner(): boolean {
    return this.service.currentStep() === STEP.EMAIL ||
      this.service.currentStep() === STEP.RUT ||
      this.service.currentStep() === STEP.PERSONAL_DATA ||
      this.service.currentStep() === STEP.SUCCESS ||
      this.service.currentStep() === STEP.PASSWORD ||
      this.service.currentStep() === STEP.CELPHONE_NUMBER ||
      this.service.currentStep() === STEP.CELPHONE_CODE ||
      this.service.currentStep() === STEP.WELCOME ||
      this.service.currentStep() === STEP.FORGOT ||
      this.service.currentStep() === STEP.NEW_PASSWORD ||
      this.service.currentStep() === STEP.FORGOT_RUT ||
      this.service.currentStep() === STEP.FORGOT_RUT_CODE ||
      this.service.currentStep() === STEP.CELPHONE_CODE ||
      this.service.currentStep() === STEP.OOPS ||
      this.service.currentStep() === STEP.RECOVERY ||
      this.service.currentStep() === STEP.SUCCESSQR ||
      this.service.currentStep() === STEP.RECOGNIZED
  }
}
